<div class="row">
  <div class="col">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">
          <a [routerLink]="['/clients-to-call']" [queryParams]="clientsToCallQueryParams">Clients to Call</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Matter Details</li>
      </ol>
    </nav>
  </div>
</div>

<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3">
  <h1 class="h2">Matter Details - {{isMatterLoading === true ? 'loading' : matterDetails.matterNumber}}</h1>
</div>
<div class="row mb-3">
  <div class="card">
    <div class="card-header">
      <h6 class="m-0">Basic Info</h6>
    </div>
    <div class="card-body">
      <ng-container *ngIf="isMatterLoading">
        <div class="loading-cover">
          <fa-icon class="me-2" [icon]="faCircleNotch" [spin]="true"></fa-icon> Loading
        </div>
      </ng-container>
      <ng-container *ngIf="!isMatterLoading && !matterDetails">
        <div class="loading-cover">
          <fa-icon class="me-2" [icon]="faTriangleExclamation"></fa-icon> Oops. Something went wrong. Please report this
          to the AppDev team.
        </div>
      </ng-container>
      <ng-container *ngIf="!isMatterLoading && matterDetails">
        <dl class="row">
          <dt class="col-sm-3">Name</dt>
          <dd class="col-sm-9"><span data-private>{{matterDetails.name}}</span></dd>

          <dt class="col-sm-3">Matter Number</dt>
          <dd class="col-sm-9">{{matterDetails.matterNumber}}
          </dd>

          <dt class="col-sm-3">Type</dt>
          <dd class="col-sm-9"><span data-private>{{matterDetails.matterTypeCode}}</span></dd>

          <dt class="col-sm-3">Retained Date</dt>
          <dd class="col-sm-9"><span data-private>{{ matterDetails.retainedDate! | formatUtcDate }}</span></dd>

          <dt class="col-sm-3">Client Phone</dt>
          <dd class="col-sm-9"><span data-private>{{matterDetails.clientContactNumber}}</span></dd>

          <dt class="col-sm-3">Client Email</dt>
          <dd class="col-sm-9"><span data-private>{{matterDetails.clientContactEmail}}</span></dd>

          <dt class="col-sm-3">Attorney</dt>
          <dd class="col-sm-9"><span data-private>{{matterDetails.attorneyName}}</span></dd>

          <dt class="col-sm-3">MP</dt>
          <dd class="col-sm-9"><span data-private>{{matterDetails.mp}}</span></dd>
        </dl>
      </ng-container>
    </div>


  </div>
</div>
<div class="row">
  <div class="card">
    <div class="card-header">
      <h6 class="m-0">Surveys</h6>
    </div>
    <div class="card-body">

      <ng-container *ngIf="isAuthLoading">
        <div class="auth-cover d-flex justify-content-center align-items-center">
          <div class="loading-cover">
            <fa-icon class="me-2" [icon]="faCircleNotch" [spin]="true"></fa-icon> Loading
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!isAuthLoading && !matterHasRepAssigned">
        <div class="auth-cover d-flex justify-content-center align-items-center">
          <div class="col text-center">
            <h5><fa-icon class="me-2 text-warning" [icon]="faTriangleExclamation"></fa-icon> No Rep Assigned</h5>
            <p>A rep must be assigned before any actions can be made. Please assign a rep on the <a class=""
                [routerLink]="['/clients-to-call']">
                Clients to Call</a> page.</p>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isSurveyTypeDetailsLoading">
        <div class="loading-cover">
          <fa-icon class="me-2" [icon]="faCircleNotch" [spin]="true"></fa-icon> Loading
        </div>
      </ng-container>
      <ng-container *ngIf="!isSurveyTypeDetailsLoading">
        <p-tabView> <p-tabPanel [header]="surveyTypeDetails.value!">
            <div class="row">
              <div class="col-12 col-xl-5 col-xxl-4">
                <h6>Survey History</h6>

                <div class="d-inline-block" pTooltip="This client does not have an email on file to send a survey to."
                  tooltipPosition="top">
                  <p-button [ngClass]="{'visually-hidden': isEmailSending}" class="btn btn-sm btn-primary m-1"
                    (click)="executeSendSurveyProcess()" pTooltip="Immediately send the survey to the client via email."
                    tooltipPosition="top" label="Send Survey via Email"
                    [disabled]="(matterDetails !== null && matterDetails !== undefined ? !matterDetails.clientContactEmail : true) || isEmailSending === true" />
                  <button type="button" *ngIf="isEmailSending" class="btn btn-sm btn-primary m-1" disabled><fa-icon
                      class="me-2" [icon]="faCircleNotch" [spin]="true"></fa-icon> Sending Email</button>
                </div>



                <p-button class="btn btn-sm btn-primary m-1" (click)="toggleTakeSurveyModal()"
                  pTooltip="Take the survey on behalf of the client." tooltipPosition="top" label="Take Survey" />
                <app-survey-history-grid [matterId]="matterId" [surveyTypeId]="surveyTypeId"
                  [matterNumber]="matterDetails ? matterDetails.matterNumber : ''" [month]="month"
                  [year]="year"></app-survey-history-grid>
              </div>
              <div class="col-12 col-xl-5 col-xxl-4">
                <h6>Contact History</h6>
                <a class="btn btn-sm btn-primary m-1" (click)="toggleAddContactHistoryModal()">
                  Add a Contact History Record</a>
                <app-contact-history-grid (outputSurveyContact)="setSurveyContact($event)" [surveyTypeId]="surveyTypeId"
                  [matterId]="matterId" [month]="month" [year]="year"></app-contact-history-grid>
              </div>

              <div class="col-12 col-xl-2 col-xxl-4">
                <h6>Note</h6>
                <div class="col mb-3">
                  <form [formGroup]="addContactNotesForm" (ngSubmit)="onContactNotesSubmit()">
                    <label class="sr-only" for="notes">Notes</label>
                    <textarea class="form-control" id="notes" rows="3" formControlName="notes"></textarea>
                    <div id="noteHelp" class="form-text">Click the note input box to edit, then save.</div>
                    <button type="submit" class="btn btn-primary btn-sm mt-2" [disabled]="!isSubmitButtonEnabled">Save
                      Note</button>
                  </form>
                </div>

              </div>
            </div>
          </p-tabPanel>
        </p-tabView>
      </ng-container>
    </div>

  </div>
</div>

<app-add-contact-history-modal (reloadParent)="reloadSurveyContact()" [surveyTypeId]="surveyTypeId"
  [matterId]="matterId" [month]="month" [year]="year"></app-add-contact-history-modal>

<app-take-survey-modal (reloadParent)="reloadSurveyHistories()" (addSurveyContact)="updateSurveyContact(false, true)"
  [surveyTypeId]="surveyTypeId" [matterId]="matterId" [surveyTypeDetails]="surveyTypeDetails"
  [attorneyId]="matterDetails !== null && matterDetails !== undefined ? matterDetails.attorneyId : null"></app-take-survey-modal>